import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./SolicitudDevolucion.css";
const API = process.env.REACT_APP_API_URL



export default function SolicitudDevolucion() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [pedido, setPedido] = useState(null);
  const [accion, setAccion] = useState("");
  const [motivo, setMotivo] = useState("");
  const [comentario, setComentario] = useState("");
  const [imagenes, setImagenes] = useState([]);
  const [productos, setProductos] = useState({});
  const [cargando, setCargando] = useState(false);

  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const renovarToken = async () => {
    console.log("Intentando renovar sesión...");
    try {
      const res = await fetch(API + "/user/refresh",{
         method:"POST",
          credentials: "include"
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.accessToken);
        window.location.reload();
        return true;
      }
    } catch (error) {
      console.error("Error crítico al renovar token:", error);
    }
    return false;
  };

  const verificarDevolucionExistente = async () => {
    try {
      const response = await fetch(
        `${API}/devolucion/traerDevolucionPedidos/${id}`,
        { headers: { Authorization: `Bearer ${token}`} }
      );
        if(response.status === 403 && await renovarToken())return;
      const data = await response.json();
      if (data.datos) {
        alert("⚠️ Este pedido ya tiene una solicitud en trámite.");
        navigate("/ClientePedidos");
      }
    } catch (error) {
      console.error("Error validando devolución", error);
    }
  };

  useEffect(() => {
    verificarDevolucionExistente();
    cargarPedido();
  }, [id]);

  const cargarPedido = async () => {
    try {
      const res = await fetch(`${API}/pedido/traerPedidosId/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if(res.status === 403 && await renovarToken())return;
      const data = await res.json();
      setPedido(data.datos);
    } catch (error) {
      console.error("Error cargando pedido", error);
    }
  };

  const eliminarImagen = (index) => {
    setImagenes((prev) => prev.filter((_, i) => i !== index));
  };

  const toggleProducto = (det) => {
    setProductos((prev) => {
      if (prev[det.id]) {
        const copia = { ...prev };
        delete copia[det.id];
        return copia;
      }
      return {
        ...prev,
        [det.id]: { productoId: det.productoId, cantidad: 1, nombre: det.nombreProducto, max: det.cantidad },
      };
    });
  };

  const actualizarCantidad = (id, valor) => {
    setProductos(prev => ({
      ...prev,
      [id]: { ...prev[id], cantidad: parseInt(valor) || 1 }
    }));
  };

  const enviarSolicitud = async () => {
    if (!accion) return alert("Selecciona una acción.");
    setCargando(true);
    const formData = new FormData();
    formData.append("pedidoId", id);
    formData.append("accion", accion);
    formData.append("motivo", motivo);
    formData.append("comentario", comentario);
    formData.append("usuarioId", user.id);

    const productosLimpios = Object.values(productos).map(p => ({
      productoId: p.productoId,
      cantidad: p.cantidad
    }));

    const productosPayload = { productosDevolucionDTOList: productosLimpios };

    formData.append(
      "productos",
      new Blob([JSON.stringify(productosPayload)], { type: "application/json" })
    );
    imagenes.forEach((file) => formData.append("imagenes", file));

    try {
      const res = await fetch( API + "/devolucion/crear", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`},
        body: formData,
      });

        if(res.status === 403 && await renovarToken())return;
      if (res.ok) {
        alert("✅ Solicitud enviada correctamente");
        navigate("/ClientePedidos");
      } else {
        alert("❌ Error al procesar");
      }
    } catch (error) {
      alert("❌ Error de conexión");
    } finally {
      setCargando(false);
    }
  };

  if (!pedido) return <div className="loader">Cargando...</div>;
  const pedidoData = pedido[0];
  const fueEntregado = pedidoData.estado === "ENTREGADO";

  return (
    <div className="dev-master-container">
      <header className="dev-header">
        <button className="btn-back" onClick={() => navigate(-1)}>← Volver</button>
        <h1>Gestión de Devolución</h1>
        <p>Pedido <strong>#{pedidoData.id}</strong></p>
      </header>

      <div className="dev-layout">
        <main className="dev-main-card">
          
          {/* PASO 1: ACCIÓN */}
          <section className="dev-section">
            <h3 className="section-title"><span className="step-num">1</span> ¿Qué deseas solicitar?</h3>
            <div className="options-grid">
              {fueEntregado && (
                <>
                  <button className={`opt-card ${accion === "DEVOLUCION_TOTAL" ? "active" : ""}`} onClick={() => setAccion("DEVOLUCION_TOTAL")}>
                    <div className="opt-icon">📦</div>
                    <div className="opt-desc">
                      <strong>Devolución Total</strong>
                      <span>Todo el pedido</span>
                    </div>
                  </button>
                  <button className={`opt-card ${accion === "DEVOLUCION_PARCIAL" ? "active" : ""}`} onClick={() => setAccion("DEVOLUCION_PARCIAL")}>
                    <div className="opt-icon">🛍️</div>
                    <div className="opt-desc">
                      <strong>Devolución Parcial</strong>
                      <span>Solo algunos artículos</span>
                    </div>
                  </button>
                </>
              )}
            </div>
          </section>

          {/* PASO 2: PRODUCTOS (CON SELECTOR DE CANTIDAD) */}
          {accion === "DEVOLUCION_PARCIAL" && (
            <section className="dev-section fade-in">
              <h3 className="section-title"><span className="step-num">2</span> Selecciona productos y cantidad</h3>
              <div className="prod-list">
                {pedidoData.detalles.map(det => (
                  <div key={det.id} className={`prod-row ${productos[det.id] ? 'selected' : ''}`}>
                    <label className="check-label">
                      <input type="checkbox" checked={!!productos[det.id]} onChange={() => toggleProducto(det)} />
                      <span className="prod-name">{det.nombreProducto}</span>
                    </label>
                    {productos[det.id] && (
                      <div className="qty-container fade-in">
                        <label>Cant:</label>
                        <input 
                          type="number" 
                          min="1" 
                          max={det.cantidad} 
                          value={productos[det.id].cantidad}
                          onChange={(e) => actualizarCantidad(det.id, e.target.value)}
                        />
                        <span className="max-qty">de {det.cantidad}</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* PASO 3: DETALLES */}
          {accion && (
            <section className="dev-section fade-in">
              <h3 className="section-title">
                <span className="step-num">{accion === "DEVOLUCION_PARCIAL" ? '3' : '2'}</span> Detalles y Evidencia
              </h3>
              
              <div className="form-group">
                <label>Motivo</label>
                <select className="dev-select" value={motivo} onChange={e => setMotivo(e.target.value)}>
                  <option value="">Selecciona un motivo...</option>
                  <option value="DAÑADO">📦 Producto dañado</option>
                  <option value="INCORRECTO">❓ Producto incorrecto</option>
                  <option value="OTRO">📝 Otro</option>
                </select>
              </div>

              <div className="form-group">
                <label>Comentarios</label>
                <textarea className="dev-textarea" placeholder="Explica brevemente el motivo de la devolución..." value={comentario} onChange={e => setComentario(e.target.value)} />
              </div>

              <div className="evidencia-box">
                <h4 className="evidencia-label">Evidencia Fotográfica ({imagenes.length}/5)</h4>
                <div className="upload-area">
                  <input type="file" multiple accept="image/*" onChange={(e) => {
                    const archivos = Array.from(e.target.files);
                    if (imagenes.length + archivos.length > 5) return alert("Máximo 5 fotos");
                    setImagenes(prev => [...prev, ...archivos]);
                    e.target.value = null;
                  }} id="up-img" hidden />
                  <label htmlFor="up-img" className="btn-select">📸 Seleccionar Fotos</label>
                </div>

                {imagenes.length > 0 && (
                  <div className="gallery-grid">
                    {imagenes.map((file, i) => (
                      <div key={i} className="gallery-item">
                        <img src={URL.createObjectURL(file)} alt="evidencia" />
                        <button type="button" className="btn-del" onClick={() => eliminarImagen(i)}>×</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </section>
          )}

          <button className="btn-submit" onClick={enviarSolicitud} disabled={cargando || !accion}>
            {cargando ? "Enviando..." : "Enviar Solicitud"}
          </button>
        </main>

        <aside className="dev-aside">
          <div className="info-card">
            <h4>💡 Tips para tu devolución</h4>
            <ul>
              <li>Asegúrate de que las fotos tengan buena luz.</li>
              <li>Muestra claramente el daño o el error.</li>
              <li>Conserva las etiquetas originales si es posible.</li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
}